import React from "react";
import { Star } from "lucide-react";

export function StarRating({ rating = 0, count, size = 14, showValue = false, className = "" }) {
  const full = Math.floor(rating);
  const hasHalf = rating - full >= 0.5;
  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid="review-stars" aria-label={`Rated ${rating} out of 5`}>
      <div className="flex items-center">
        {[0, 1, 2, 3, 4].map((i) => {
          const filled = i < full || (i === full && hasHalf);
          return (
            <Star
              key={i}
              style={{ width: size, height: size }}
              className={filled ? "fill-gold text-gold" : "text-gold/30"}
            />
          );
        })}
      </div>
      {showValue && <span className="text-xs text-muted-foreground">{rating.toFixed(1)}</span>}
      {count != null && <span className="text-xs text-muted-foreground">({count})</span>}
    </div>
  );
}
